import React from 'react'

// styled-components 4 forwards every prop to a component target, so $-prefixed
// "transient" props (natively stripped only from v5.1) get spread onto the DOM
// by base-ui primitives, triggering React invalid-attribute warnings. Wrapping
// the target drops them after styled() has already used them for interpolation.
const stripTransientProps = (Component) => {
  const Stripped = React.forwardRef((props, ref) => {
    const forwarded = {}
    Object.keys(props).forEach((key) => {
      if (key[0] !== '$') forwarded[key] = props[key]
    })
    // eslint-disable-next-line react/jsx-props-no-spreading -- pass-through wrapper by design
    return <Component ref={ref} {...forwarded} />
  })
  Stripped.displayName = `stripTransientProps(${
    Component.displayName || Component.name || 'Component'
  })`
  return Stripped
}

export default stripTransientProps
